/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-08-09 16:26:10
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-08-09 17:52:39
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/OchamaMigTrack.tsx
 * @Description: default
 */
'use client';
import useOchamaMig from '@/hooks/useOchamaMig';
export default function OchamaMigTrack(props: { trackType: string }) {
  useOchamaMig(props.trackType);
  return <></>;
}
